import axios from "axios";
import debounce from "lodash.debounce";
import autoBind from 'auto-bind';
import ReLogin from '../../api/relogin';
import store from '../../state/store';
import {onMessageActions} from "./event";
import {mockMessage} from "./mockMessage";
import onMessageMessageNew from "./event/onMessageMessageNew";

const updateCountersDebounce = debounce(() => store.dispatch('rooms/updateCounters'), 500);

let pingInterval;

class ServiceChat {
  topics = ['chat'];

  constructor () {
    autoBind(this);
  }

  Init() {
  }

  Fin() {
    store.commit('rooms/SET_WS_CONNECT', false);
  }

  onMessage ({ body: dataJson }) {
    //console.log('chat.onMessage | ', dataJson.meta.type, ' | data = ', data, '  | dataJson = ', dataJson);

    onMessageActions[dataJson.meta.type] && onMessageActions[dataJson.meta.type](dataJson);

    if (["/message/typing"].includes(dataJson.meta.type) === false) {
      updateCountersDebounce();
    }
  }

  async OnTyping ({ chat_id }) {
    const msg = {
      meta: {type: "/message/typing"},
      body: {chat_id},
    };

    try {
      // ws.send(JSON.stringify(msg));
      await axios.post('/chats/api/v1/message/typing', msg);
    } catch (e) {
      console.error('chat | OnTyping | e = ', e);
    }
  }

  async OnNew ({ chat_id, uniq_seq, message }) {

    const type = "/message/new";
    const id = Date.now();
    const user_id = store.state.auth.user.id;
    const created_at = new Date().toUTCString();

    message = {...message, id, user_id, created_at};
    if (!!message.payload) {
      message.payload = message.payload.trim();
    }

    const msg = {
      meta: {type, id},
      body: {chat_id, uniq_seq, message},
    };
    const meta_id = id;
    const is_sending = true;
    const retry = JSON.stringify(msg);

    store.commit('rooms/ADD_MESSAGE_LAST', {...msg.body.message, chat_id, uniq_seq, meta_id, retry, is_sending});
    store.commit('room/ADD_MESSAGE', {...msg.body, chat_id, meta_id, retry, is_sending});

    try {
      // ws.send(JSON.stringify(msg));
      await axios.post('/chats/api/v1/message/new', msg).then(resp => onMessageMessageNew(resp.data));
    } catch (e) {
      console.error('chat | OnNew | e = ', e, e.response.data);
      store.commit('room/ERROR_MESSAGES', { ...e.response.data, meta_id: msg.meta.id });
    }

    return true;
  }

  async OnRetryByMetaId(meta_id) {
    console.info('chat | OnRetryByMetaId(', meta_id, ')');

    const data = store.state.room.messagesRetry[meta_id];
    if (!data) return;

    const msg = JSON.parse(data);

    store.commit('room/DELETE_MESSAGE', {meta_id});

    const id = Date.now();
    const created_at = new Date().toUTCString();
    const uniq_seq = id + '-' + Math.random();

    msg.body.message.created_at = created_at;
    msg.body.message.id = id;
    msg.body.uniq_seq = uniq_seq;
    msg.meta.id = id;

    const is_sending = true;
    const retry = JSON.stringify(msg);

    store.commit('room/ADD_MESSAGE', {...msg.body, meta_id: id, retry, is_sending});

    try {
      // ws.send(JSON.stringify(msg));
      await axios.post('/chats/api/v1/message/new', msg).then(resp => this.OnMessageNew(resp.data));
    } catch (e) {
      console.error('chat | OnRetry | e = ', e);
      store.commit('room/ERROR_MESSAGES', { ...e.response.data, meta_id: msg.meta.id });
      return false;
    }

    return true;
  }

  async OnRetryById(message_id) {
    console.info('chat | OnRetryById(', message_id, ')');

    store.commit('room/DELETE_MESSAGE', {message_id});

    const msgFind = store.state.room.messages.find(m => m.id === message_id);
    try {
      await axios.post('/chats/api/v1/message/delete', {
        meta: {type: "/message/delete", id: Date.now()},
        body: {chat_id: msgFind.chat_id, message_id},
      });
    } catch (e) {
      console.error('chat | OnRetryById | /message/delete | e = ', e);
    }

    const id = Date.now();
    const user_id = store.state.auth.user.id;
    const created_at = new Date().toUTCString();
    const uniq_seq = id + '-' + Math.random();

    const message = {...msgFind, id, user_id, created_at};
    const body = {chat_id: msgFind.chat_id, uniq_seq, message};
    const msg = {meta: {type: "/message/new", id: message.id}, body};
    const meta_id = id;
    const retry = JSON.stringify(msg);
    const is_sending = true;

    store.commit('room/ADD_MESSAGE', {
      ...body,
      meta_id, retry, is_sending,
    });

    try {
      // ws.send(JSON.stringify(msg));
      await axios.post('/chats/api/v1/message/new', msg).then(resp => this.OnMessageNew(resp.data));
    } catch (e) {
      console.error('chat | OnRetryById | /message/new | e = ', e);
      store.commit('room/ERROR_MESSAGES', { ...e.response.data, meta_id: msg.meta.id });
      return false;
    }

    return true;
  }

  async OnRead(chat_id, message_id) {
    const id = Date.now();
    const type = "/message/read";
    const msg = {meta: {type, id}, body: {chat_id, message_id}};

    try {
      store.commit('rooms/READ_MESSAGE', {chat_id});
      //ws.send(JSON.stringify(msg));
      await axios.post('/chats/api/v1/message/read', msg);
    } catch (e) {
      store.commit('rooms/UNREAD_MESSAGE', {chat_id});
      console.error('chat | OnRead | e = ', e);
      return false;
    }

    return true;
  }
}

export default new ServiceChat();
